import { logger } from 'packages/logger';
import { isServer } from 'tradera/utils/nextjs';
import { loadScript } from 'tradera/utils/script';
import type { AdFormat } from './ad-format';

export async function initHolid(useBeta: boolean) {
    if (isServer) {
        throw new Error(
            'Do not run on server. Loads a script - the DOM is not available on the server.'
        );
    }

    const url = useBeta
        ? `https://ads.holid.io/auto/beta.tradera.com/holid.js`
        : `https://ads.holid.io/auto/tradera.com/holid.js`;

    try {
        await loadScript(url);
    } catch (error) {
        console.error('holidAds errors:', error);
    }

    if (useBeta) {
        console.log('Holid BETA initialized');
    }
}

export const getAdSize = (adFormat: AdFormat): [number, number] => {
    switch (adFormat) {
        case 'tower':
            return [300, 600];
        case 'mobile':
            return [320, 320];
        case 'box':
            return [320, 360];
        case 'widescreen':
            return [980, 300];
        case 'custom0':
            return [260, 600];
        case 'custom1':
        case 'custom2':
            return [300, 300];
        default:
            logger(new Error('Invalid ad format for Holid ads'), {
                contexts: { ad: { adFormat } }
            });
            return [0, 0];
    }
};
